
import { defineComponent } from 'vue'
import AboutMe from '@/components/en/top/AboutMe.vue'
import UpdateNews from '@/components/en/top/UpdateNews.vue'
import ContactInfo from '@/components/en/top/ContactInfo.vue'

export default defineComponent({
  name: 'TopEn',
  components: {
    AboutMe,
    UpdateNews,
    ContactInfo
  },
  emits: [
    'Activate'
  ],
  mounted () {
    console.log('mounted')
    this.$emit('Activate', this.activate())
  },
  methods: {
    activate () {
      return 'top'
    }
  }
})
